/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  DateTimeOffset: string;
  Decimal: string;
  Milliseconds: string;
  Seconds: string;
};

export enum ApproveEpicTenantConfigErrors {
  TenantConfigNotFound = 'TENANT_CONFIG_NOT_FOUND',
  TenantConfigAlreadyApproved = 'TENANT_CONFIG_ALREADY_APPROVED',
  TenantConfigAlreadyApprovedForAnotherTenant = 'TENANT_CONFIG_ALREADY_APPROVED_FOR_ANOTHER_TENANT',
  EpicAuthSessionNotFound = 'EPIC_AUTH_SESSION_NOT_FOUND'
}

export type ApproveEpicTenantConfigException = {
  readonly __typename?: 'ApproveEpicTenantConfigException';
  readonly error?: Maybe<ApproveEpicTenantConfigErrors>;
};

export type ApproveEpicTenantConfigUnionResult = EpicTenantConfigType | ApproveEpicTenantConfigException | EpicServerErrorException;

export enum CernerEnvironment {
  Unknown = 'UNKNOWN',
  Test = 'TEST',
  Prod = 'PROD'
}

export type CernerIntegrationRecordSettingsType = {
  readonly __typename?: 'CernerIntegrationRecordSettingsType';
  readonly providerClientId: Scalars['String'];
  readonly providerLaunchUrl: Scalars['String'];
};

export type CernerTenantConfigType = {
  readonly __typename?: 'CernerTenantConfigType';
  readonly cernerEnv?: Maybe<CernerEnvironment>;
  readonly externalOrgId: Scalars['String'];
  readonly issuerUrl: Scalars['String'];
  readonly fHIRURLNickname?: Maybe<Scalars['String']>;
  readonly m365TenantId: Scalars['String'];
  readonly m365TenantName: Scalars['String'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly timeZone?: Maybe<Scalars['String']>;
};

export type CernerTenantConfigTypeUnionResult = CernerTenantConfigType | CreateTenantConfigException;

export enum CountryCode {
  None = 'NONE',
  Us = 'US',
  Gb = 'GB'
}

export enum CreateEpicTenantConfigErrors {
  IssuerUrlInvalid = 'ISSUER_URL_INVALID',
  EpicAdminsInvalid = 'EPIC_ADMINS_INVALID',
  EpicAdminsEmpty = 'EPIC_ADMINS_EMPTY'
}

export type CreateEpicTenantConfigException = {
  readonly __typename?: 'CreateEpicTenantConfigException';
  readonly error?: Maybe<CreateEpicTenantConfigErrors>;
};

export type CreateEpicTenantConfigUnionResult = EpicTenantConfigType | CreateEpicTenantConfigException | EpicServerErrorException;

export enum CreateTenantConfigErrors {
  IssuerUrlInvalid = 'ISSUER_URL_INVALID'
}

export type CreateTenantConfigException = {
  readonly __typename?: 'CreateTenantConfigException';
  readonly error?: Maybe<CreateTenantConfigErrors>;
};





export enum EpicEnvironment {
  Unknown = 'UNKNOWN',
  Test = 'TEST',
  Prod = 'PROD'
}

export type EpicErrorType = {
  readonly __typename?: 'EpicErrorType';
  readonly errorMessage: Scalars['String'];
  readonly isRetryable: Scalars['Boolean'];
  readonly statusCode: Scalars['Int'];
};

export type EpicHl7ClientCertificateType = {
  readonly __typename?: 'EpicHL7ClientCertificateType';
  readonly certificateThumbprint: Scalars['String'];
  readonly epicEnv?: Maybe<EpicEnvironment>;
  readonly externalSource: Scalars['String'];
};

export type EpicIntegrationRecordSettingsType = {
  readonly __typename?: 'EpicIntegrationRecordSettingsType';
  readonly directJoinClientId?: Maybe<Scalars['String']>;
  readonly directJoinContextToken?: Maybe<Scalars['String']>;
  readonly directJoinLaunchUrl?: Maybe<Scalars['String']>;
  readonly directJoinLaunchShortUrl?: Maybe<Scalars['String']>;
  readonly hL7EventPostUrl?: Maybe<Scalars['String']>;
  readonly patientClientId: Scalars['String'];
  readonly patientContextToken: Scalars['String'];
  readonly patientLaunchUrl: Scalars['String'];
  readonly deviceTesterContextToken?: Maybe<Scalars['String']>;
  readonly providerClientId: Scalars['String'];
  readonly providerContextToken: Scalars['String'];
  readonly providerLaunchUrl: Scalars['String'];
};

export type EpicServerErrorException = {
  readonly __typename?: 'EpicServerErrorException';
  readonly error?: Maybe<EpicErrorType>;
};

export type EpicTenantConfigType = {
  readonly __typename?: 'EpicTenantConfigType';
  readonly epicAdminIds: ReadonlyArray<Scalars['String']>;
  readonly epicEnv?: Maybe<EpicEnvironment>;
  readonly externalOrgId: Scalars['String'];
  readonly isApproved: Scalars['Boolean'];
  readonly issuerUrl: Scalars['String'];
  readonly fHIRURLNickname?: Maybe<Scalars['String']>;
  readonly m365TenantId: Scalars['String'];
  readonly m365TenantName: Scalars['String'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly timeZone?: Maybe<Scalars['String']>;
};

export type EpicUserContextType = {
  readonly __typename?: 'EpicUserContextType';
  readonly isAdmin: Scalars['Boolean'];
  readonly userName: Scalars['String'];
};

export enum ErrorSubType {
  UnauthorizedAccessException = 'UNAUTHORIZED_ACCESS_EXCEPTION',
  AuthStateInvalid = 'AUTH_STATE_INVALID',
  AadStateInvalid = 'AAD_STATE_INVALID',
  UserIsNotAdmin = 'USER_IS_NOT_ADMIN',
  LicenseNotFound = 'LICENSE_NOT_FOUND',
  InvalidSession = 'INVALID_SESSION',
  IssuerUrlInvalid = 'ISSUER_URL_INVALID',
  NoTenantConfigsConfigured = 'NO_TENANT_CONFIGS_CONFIGURED',
  ErrorEpicAdminsInvalid = 'ERROR_EPIC_ADMINS_INVALID',
  ErrorTenantConfigNotFound = 'ERROR_TENANT_CONFIG_NOT_FOUND',
  UserConfigNotFound = 'USER_CONFIG_NOT_FOUND',
  PhoneConfigNotFound = 'PHONE_CONFIG_NOT_FOUND',
  TenantNotFound = 'TENANT_NOT_FOUND',
  SessionExpired = 'SESSION_EXPIRED',
  TenantSuspended = 'TENANT_SUSPENDED',
  InvalidEnvironment = 'INVALID_ENVIRONMENT',
  CannotAcquireAccessToken = 'CANNOT_ACQUIRE_ACCESS_TOKEN',
  CannotCreateMeeting = 'CANNOT_CREATE_MEETING',
  BotCannotJoinMeeting = 'BOT_CANNOT_JOIN_MEETING',
  CannotStampEhrExtension = 'CANNOT_STAMP_EHR_EXTENSION',
  CosmosDbNonRetryableError = 'COSMOS_DB_NON_RETRYABLE_ERROR',
  CosmosDbRetryableError = 'COSMOS_DB_RETRYABLE_ERROR',
  AppointmentNotFound = 'APPOINTMENT_NOT_FOUND',
  AppointmentStatusInvalid = 'APPOINTMENT_STATUS_INVALID',
  PatientInactive = 'PATIENT_INACTIVE',
  EncounterHasNoAppointmentReference = 'ENCOUNTER_HAS_NO_APPOINTMENT_REFERENCE',
  EncounterHasMultipleAppointmentReferences = 'ENCOUNTER_HAS_MULTIPLE_APPOINTMENT_REFERENCES',
  NotVirtualVisit = 'NOT_VIRTUAL_VISIT',
  SubjectNotPatient = 'SUBJECT_NOT_PATIENT',
  AccessTokenInvalid = 'ACCESS_TOKEN_INVALID',
  CannotGetAadCertificate = 'CANNOT_GET_AAD_CERTIFICATE'
}

export enum ErrorType {
  UnAuthorizedAccessError = 'UN_AUTHORIZED_ACCESS_ERROR',
  ClientError = 'CLIENT_ERROR',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  CernerError = 'CERNER_ERROR',
  DataNotFoundError = 'DATA_NOT_FOUND_ERROR'
}

export enum GetEpicUserContextsErrors {
  TenantConfigNotFound = 'TENANT_CONFIG_NOT_FOUND',
  EpicAuthSessionNotFound = 'EPIC_AUTH_SESSION_NOT_FOUND',
  EpicError = 'EPIC_ERROR'
}

export type GetEpicUserContextsException = {
  readonly __typename?: 'GetEpicUserContextsException';
  readonly error?: Maybe<GetEpicUserContextsErrors>;
};

export type GetEpicUserContextsUnionResult = EpicUserContextType | GetEpicUserContextsException | EpicServerErrorException;

export type Hl7CertificateUploadResultType = {
  readonly __typename?: 'HL7CertificateUploadResultType';
  readonly error?: Maybe<Hl7ClientCertificateUploadErrors>;
  readonly status?: Maybe<Hl7ClientCertificateUploadStatus>;
  readonly thumbprint?: Maybe<Scalars['String']>;
};

export enum Hl7ClientCertificateUploadErrors {
  NoError = 'NO_ERROR',
  MalwareError = 'MALWARE_ERROR',
  EncodingError = 'ENCODING_ERROR',
  SizeError = 'SIZE_ERROR',
  AlreadyUploadedError = 'ALREADY_UPLOADED_ERROR',
  MalwareCheckTimeoutError = 'MALWARE_CHECK_TIMEOUT_ERROR',
  MalwareCheckFailureError = 'MALWARE_CHECK_FAILURE_ERROR',
  MalwareCheckSkippedError = 'MALWARE_CHECK_SKIPPED_ERROR',
  MalwareCheckUnknownError = 'MALWARE_CHECK_UNKNOWN_ERROR',
  UnknownError = 'UNKNOWN_ERROR',
  MissingPublicKey = 'MISSING_PUBLIC_KEY',
  HasPrivateKey = 'HAS_PRIVATE_KEY',
  MissingThumbprint = 'MISSING_THUMBPRINT',
  ExpiredValidity = 'EXPIRED_VALIDITY',
  UnknownEnvironment = 'UNKNOWN_ENVIRONMENT'
}

export enum Hl7ClientCertificateUploadStatus {
  Success = 'SUCCESS',
  Failure = 'FAILURE'
}


export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly approveEpicTenantConfig_v2?: Maybe<ApproveEpicTenantConfigUnionResult>;
  readonly createCernerTenantConfig?: Maybe<CernerTenantConfigTypeUnionResult>;
  readonly createEpicTenantConfig_v2?: Maybe<CreateEpicTenantConfigUnionResult>;
  readonly createTenantPhoneNumber?: Maybe<PhoneNumberSettingType>;
  readonly deleteCernerTenantConfig?: Maybe<Scalars['Boolean']>;
  readonly deleteEpicHL7ClientCertificate?: Maybe<Scalars['Boolean']>;
  readonly deleteEpicTenantConfig?: Maybe<Scalars['Boolean']>;
  readonly deleteTenantPhoneNumber?: Maybe<Scalars['Boolean']>;
  readonly linkTenantPhoneNumber?: Maybe<Scalars['Boolean']>;
  readonly setEpicSMSNotificationSettings?: Maybe<NotificationSettingType>;
  readonly unlinkTenantPhoneNumber?: Maybe<Scalars['Boolean']>;
  readonly updateCernerAdminPrivacyConsent: Scalars['Boolean'];
  readonly updateCernerAttendeePrivacyConsent: Scalars['Boolean'];
  readonly updateEpicAdminPrivacyConsent: Scalars['Boolean'];
  readonly updateEpicAttendeePrivacyConsent: Scalars['Boolean'];
  readonly updateEpicTenantConfig?: Maybe<EpicTenantConfigType>;
  readonly updateTimeZone: Scalars['Boolean'];
  readonly uploadEpicHL7ClientCertificate?: Maybe<Hl7CertificateUploadResultType>;
};


export type MutationApproveEpicTenantConfig_V2Args = {
  externalOrgId: Scalars['String'];
};


export type MutationCreateCernerTenantConfigArgs = {
  cernerEnv?: Maybe<CernerEnvironment>;
  issuerUrl: Scalars['String'];
  fHIRURLNickname?: Maybe<Scalars['String']>;
};


export type MutationCreateEpicTenantConfig_V2Args = {
  epicEnv?: Maybe<EpicEnvironment>;
  issuerUrl: Scalars['String'];
  fHIRURLNickname?: Maybe<Scalars['String']>;
  epicAdminIds: ReadonlyArray<Scalars['String']>;
};


export type MutationCreateTenantPhoneNumberArgs = {
  countryCode: CountryCode;
};


export type MutationDeleteCernerTenantConfigArgs = {
  externalOrgId: Scalars['String'];
};


export type MutationDeleteEpicHl7ClientCertificateArgs = {
  epicEnv: EpicEnvironment;
};


export type MutationDeleteEpicTenantConfigArgs = {
  externalOrgId: Scalars['String'];
};


export type MutationDeleteTenantPhoneNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationLinkTenantPhoneNumberArgs = {
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationSetEpicSmsNotificationSettingsArgs = {
  externalOrgId: Scalars['String'];
  notificationTypes: ReadonlyArray<Maybe<Notification>>;
  notifyAheadTimeIntervals?: Maybe<ReadonlyArray<Maybe<NotifyAheadTimeInterval>>>;
};


export type MutationUnlinkTenantPhoneNumberArgs = {
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
};


export type MutationUpdateCernerAdminPrivacyConsentArgs = {
  privacyConsentAccepted: Scalars['Boolean'];
};


export type MutationUpdateCernerAttendeePrivacyConsentArgs = {
  privacyConsentAccepted: Scalars['Boolean'];
};


export type MutationUpdateEpicAdminPrivacyConsentArgs = {
  privacyConsentAccepted: Scalars['Boolean'];
};


export type MutationUpdateEpicAttendeePrivacyConsentArgs = {
  privacyConsentAccepted: Scalars['Boolean'];
};


export type MutationUpdateEpicTenantConfigArgs = {
  externalOrgId: Scalars['String'];
  issuerUrl?: Maybe<Scalars['String']>;
  fHIRURLNickname?: Maybe<Scalars['String']>;
  epicAdminIds?: Maybe<ReadonlyArray<Scalars['String']>>;
};


export type MutationUpdateTimeZoneArgs = {
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
  timeZoneId?: Maybe<Scalars['String']>;
};


export type MutationUploadEpicHl7ClientCertificateArgs = {
  epicEnv: EpicEnvironment;
  certificateFileContent: Scalars['String'];
};

export enum Notification {
  SmsConfirmation = 'SMS_CONFIRMATION',
  SmsReminder = 'SMS_REMINDER'
}

export type NotificationSettingType = {
  readonly __typename?: 'NotificationSettingType';
  readonly externalOrgId: Scalars['String'];
  readonly notificationTypes?: Maybe<ReadonlyArray<Maybe<Notification>>>;
  readonly notifyAheadTimeIntervals?: Maybe<ReadonlyArray<Maybe<NotifyAheadTimeInterval>>>;
};

export type NotificationTemplatesType = {
  readonly __typename?: 'NotificationTemplatesType';
  readonly confirmationNotificationTemplate?: Maybe<Scalars['String']>;
  readonly reminderNotificationTemplate?: Maybe<Scalars['String']>;
};

export enum NotifyAheadTimeInterval {
  Hour_1 = 'HOUR_1',
  Hours_8 = 'HOURS_8',
  Hours_24 = 'HOURS_24'
}

export enum PhoneNumberProvisionState {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  None = 'NONE'
}

export type PhoneNumberSettingType = {
  readonly __typename?: 'PhoneNumberSettingType';
  readonly countryCode?: Maybe<CountryCode>;
  readonly createdBy?: Maybe<Scalars['String']>;
  readonly createdDateTime?: Maybe<Scalars['DateTime']>;
  readonly linkedEhrVendors?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly provisionState?: Maybe<PhoneNumberProvisionState>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly downloadEpicHL7ClientCertificate?: Maybe<Scalars['String']>;
  readonly errorSubType?: Maybe<ErrorSubType>;
  readonly errorType?: Maybe<ErrorType>;
  readonly getAriaIngestionKey?: Maybe<Scalars['String']>;
  readonly getCernerAdminPrivacyConsent: Scalars['Boolean'];
  readonly getCernerAttendeePrivacyConsent: Scalars['Boolean'];
  readonly getCernerIntegrationRecordSettings?: Maybe<CernerIntegrationRecordSettingsType>;
  readonly getCernerNotificationTemplates?: Maybe<NotificationTemplatesType>;
  readonly getCernerTenantConfigs?: Maybe<ReadonlyArray<Maybe<CernerTenantConfigType>>>;
  readonly getEhrVendorContexts?: Maybe<ReadonlyArray<Maybe<VendorContextType>>>;
  readonly getEpicAdminPrivacyConsent: Scalars['Boolean'];
  readonly getEpicAttendeePrivacyConsent: Scalars['Boolean'];
  readonly getEpicAuthorizeUrlStandalone?: Maybe<Scalars['String']>;
  readonly getEpicHL7ClientCertificates?: Maybe<ReadonlyArray<Maybe<EpicHl7ClientCertificateType>>>;
  readonly getEpicIntegrationRecordSettings?: Maybe<EpicIntegrationRecordSettingsType>;
  readonly getEpicNotificationTemplates?: Maybe<NotificationTemplatesType>;
  readonly getEpicPatientLaunchMeetingLobbyContinueUrl?: Maybe<Scalars['String']>;
  readonly getEpicSMSNotificationSettings?: Maybe<NotificationSettingType>;
  readonly getEpicTenantConfig?: Maybe<EpicTenantConfigType>;
  readonly getEpicTenantConfigs?: Maybe<ReadonlyArray<Maybe<EpicTenantConfigType>>>;
  readonly getEpicTenantConfigsNonAdmin?: Maybe<ReadonlyArray<Maybe<EpicTenantConfigType>>>;
  readonly getEpicUserContext?: Maybe<EpicUserContextType>;
  readonly getEpicUserContexts?: Maybe<ReadonlyArray<Maybe<GetEpicUserContextsUnionResult>>>;
  readonly getTenantPhoneNumbers?: Maybe<ReadonlyArray<Maybe<PhoneNumberSettingType>>>;
  readonly getTimeZone?: Maybe<Scalars['String']>;
  readonly getTimeZones?: Maybe<ReadonlyArray<Maybe<TimeZoneInfoType>>>;
  readonly getUserContext?: Maybe<UserContextType>;
  readonly validateIssuerUrl?: Maybe<ValidationResultType>;
};


export type QueryDownloadEpicHl7ClientCertificateArgs = {
  epicEnv: EpicEnvironment;
};


export type QueryGetCernerIntegrationRecordSettingsArgs = {
  externalOrgId: Scalars['String'];
};


export type QueryGetCernerNotificationTemplatesArgs = {
  cernerEnv: CernerEnvironment;
};


export type QueryGetEpicAuthorizeUrlStandaloneArgs = {
  epicEnv?: Maybe<Scalars['String']>;
  issuerUrl: Scalars['String'];
};


export type QueryGetEpicIntegrationRecordSettingsArgs = {
  externalOrgId: Scalars['String'];
};


export type QueryGetEpicNotificationTemplatesArgs = {
  externalOrgId: Scalars['String'];
  epicEnv: EpicEnvironment;
};


export type QueryGetEpicPatientLaunchMeetingLobbyContinueUrlArgs = {
  sessionId: Scalars['String'];
};


export type QueryGetEpicSmsNotificationSettingsArgs = {
  externalOrgId: Scalars['String'];
};


export type QueryGetEpicUserContextsArgs = {
  externalOrgIds?: Maybe<ReadonlyArray<Scalars['String']>>;
};


export type QueryGetTimeZoneArgs = {
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
};


export type QueryValidateIssuerUrlArgs = {
  issuerUrl: Scalars['String'];
  externalOrgId?: Maybe<Scalars['String']>;
  env: Scalars['String'];
};


export type TimeZoneInfoType = {
  readonly __typename?: 'TimeZoneInfoType';
  readonly displayName: Scalars['String'];
  readonly id: Scalars['String'];
};

export type UserContextType = {
  readonly __typename?: 'UserContextType';
  readonly isTenantAdmin: Scalars['Boolean'];
  readonly locale: Scalars['String'];
  readonly regionalEndpoint: Scalars['String'];
  readonly tenantName: Scalars['String'];
  readonly timeZone?: Maybe<Scalars['String']>;
};

export enum ValidationReason {
  None = 'NONE',
  InvalidFormat = 'INVALID_FORMAT',
  InvalidUrlFormat = 'INVALID_URL_FORMAT',
  InvalidIssuerUrl = 'INVALID_ISSUER_URL',
  IssuerUrlUnavailable = 'ISSUER_URL_UNAVAILABLE',
  IssuerUrlNotFound = 'ISSUER_URL_NOT_FOUND',
  InvalidAuthorizeTokenEndpoint = 'INVALID_AUTHORIZE_TOKEN_ENDPOINT',
  InvalidIntrospectEndpoint = 'INVALID_INTROSPECT_ENDPOINT',
  EpicServiceUnavailable = 'EPIC_SERVICE_UNAVAILABLE',
  EpicServiceError = 'EPIC_SERVICE_ERROR',
  CernerServiceUnavailable = 'CERNER_SERVICE_UNAVAILABLE',
  CernerServiceError = 'CERNER_SERVICE_ERROR'
}

export type ValidationResultType = {
  readonly __typename?: 'ValidationResultType';
  readonly errorMessage?: Maybe<Scalars['String']>;
  readonly isValid: Scalars['Boolean'];
  readonly reason?: Maybe<ValidationReason>;
};

export type VendorContextType = {
  readonly __typename?: 'VendorContextType';
  readonly ehrVendor: Scalars['String'];
  readonly isCustomerAnalyst?: Maybe<Scalars['Boolean']>;
};

export type ApproveEpicTenantConfigMutationVariables = Exact<{
  externalOrgId: Scalars['String'];
}>;


export type ApproveEpicTenantConfigMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly approveEpicTenantConfig_v2?: Maybe<(
    { readonly __typename?: 'EpicTenantConfigType' }
    & Pick<EpicTenantConfigType, 'epicAdminIds' | 'epicEnv' | 'externalOrgId' | 'isApproved' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId' | 'm365TenantName'>
  ) | (
    { readonly __typename?: 'ApproveEpicTenantConfigException' }
    & Pick<ApproveEpicTenantConfigException, 'error'>
  ) | (
    { readonly __typename?: 'EpicServerErrorException' }
    & { readonly epicError?: Maybe<(
      { readonly __typename?: 'EpicErrorType' }
      & Pick<EpicErrorType, 'errorMessage' | 'statusCode' | 'isRetryable'>
    )> }
  )> }
);

export type CreateCernerTenantConfigMutationVariables = Exact<{
  issuerUrl: Scalars['String'];
  fHIRURLNickname?: Maybe<Scalars['String']>;
  cernerEnv: CernerEnvironment;
}>;


export type CreateCernerTenantConfigMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createCernerTenantConfig?: Maybe<(
    { readonly __typename?: 'CernerTenantConfigType' }
    & Pick<CernerTenantConfigType, 'externalOrgId' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId' | 'm365TenantName' | 'cernerEnv'>
  ) | (
    { readonly __typename?: 'CreateTenantConfigException' }
    & Pick<CreateTenantConfigException, 'error'>
  )> }
);

export type CreateTenantConfigMutationVariables = Exact<{
  issuerUrl: Scalars['String'];
  fHIRURLNickname?: Maybe<Scalars['String']>;
  epicAdminIds: ReadonlyArray<Scalars['String']> | Scalars['String'];
  epicEnv: EpicEnvironment;
}>;


export type CreateTenantConfigMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createEpicTenantConfig_v2?: Maybe<(
    { readonly __typename?: 'EpicTenantConfigType' }
    & Pick<EpicTenantConfigType, 'externalOrgId' | 'isApproved' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId' | 'm365TenantName' | 'epicAdminIds' | 'epicEnv'>
  ) | (
    { readonly __typename?: 'CreateEpicTenantConfigException' }
    & Pick<CreateEpicTenantConfigException, 'error'>
  ) | (
    { readonly __typename?: 'EpicServerErrorException' }
    & { readonly epicError?: Maybe<(
      { readonly __typename?: 'EpicErrorType' }
      & Pick<EpicErrorType, 'errorMessage' | 'statusCode' | 'isRetryable'>
    )> }
  )> }
);

export type CreateTenantPhoneNumberMutationVariables = Exact<{
  countryCode: CountryCode;
}>;


export type CreateTenantPhoneNumberMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createTenantPhoneNumber?: Maybe<(
    { readonly __typename?: 'PhoneNumberSettingType' }
    & Pick<PhoneNumberSettingType, 'countryCode' | 'createdBy' | 'createdDateTime' | 'linkedEhrVendors' | 'phoneNumber' | 'provisionState'>
  )> }
);

export type DeleteCernerTenantConfigMutationVariables = Exact<{
  externalOrgId: Scalars['String'];
}>;


export type DeleteCernerTenantConfigMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteCernerTenantConfig'>
);

export type DeleteEpicHl7ClientCertificateMutationVariables = Exact<{
  epicEnv: EpicEnvironment;
}>;


export type DeleteEpicHl7ClientCertificateMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteEpicHL7ClientCertificate'>
);

export type DeleteEpicTenantConfigMutationVariables = Exact<{
  externalOrgId: Scalars['String'];
}>;


export type DeleteEpicTenantConfigMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteEpicTenantConfig'>
);

export type DeleteTenantPhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type DeleteTenantPhoneNumberMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteTenantPhoneNumber'>
);

export type LinkTenantPhoneNumberMutationVariables = Exact<{
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type LinkTenantPhoneNumberMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'linkTenantPhoneNumber'>
);

export type SetEpicSmsNotificationSettingsMutationVariables = Exact<{
  externalOrgId: Scalars['String'];
  notificationTypes: ReadonlyArray<Maybe<Notification>> | Maybe<Notification>;
  notifyAheadTimeIntervals?: Maybe<ReadonlyArray<Maybe<NotifyAheadTimeInterval>> | Maybe<NotifyAheadTimeInterval>>;
}>;


export type SetEpicSmsNotificationSettingsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly setEpicSMSNotificationSettings?: Maybe<(
    { readonly __typename?: 'NotificationSettingType' }
    & Pick<NotificationSettingType, 'externalOrgId' | 'notificationTypes' | 'notifyAheadTimeIntervals'>
  )> }
);

export type UnlinkTenantPhoneNumberMutationVariables = Exact<{
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
}>;


export type UnlinkTenantPhoneNumberMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'unlinkTenantPhoneNumber'>
);

export type UpdateCernerAdminPrivacyConsentMutationVariables = Exact<{
  privacyConsentAccepted: Scalars['Boolean'];
}>;


export type UpdateCernerAdminPrivacyConsentMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'updateCernerAdminPrivacyConsent'>
);

export type UpdateCernerAttendeePrivacyConsentMutationVariables = Exact<{
  privacyConsentAccepted: Scalars['Boolean'];
}>;


export type UpdateCernerAttendeePrivacyConsentMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'updateCernerAttendeePrivacyConsent'>
);

export type UpdateEpicAdminPrivacyConsentMutationVariables = Exact<{
  privacyConsentAccepted: Scalars['Boolean'];
}>;


export type UpdateEpicAdminPrivacyConsentMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'updateEpicAdminPrivacyConsent'>
);

export type UpdateEpicAttendeePrivacyConsentMutationVariables = Exact<{
  privacyConsentAccepted: Scalars['Boolean'];
}>;


export type UpdateEpicAttendeePrivacyConsentMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'updateEpicAttendeePrivacyConsent'>
);

export type UpdateEpicTenantConfigMutationVariables = Exact<{
  externalOrgId: Scalars['String'];
  issuerUrl?: Maybe<Scalars['String']>;
  fHIRURLNickname?: Maybe<Scalars['String']>;
  epicAdminIds?: Maybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateEpicTenantConfigMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateEpicTenantConfig?: Maybe<(
    { readonly __typename?: 'EpicTenantConfigType' }
    & Pick<EpicTenantConfigType, 'externalOrgId' | 'isApproved' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId'>
  )> }
);

export type UpdateTimeZoneMutationVariables = Exact<{
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
  timeZoneId?: Maybe<Scalars['String']>;
}>;


export type UpdateTimeZoneMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'updateTimeZone'>
);

export type UploadEpicHl7ClientCertificateMutationVariables = Exact<{
  epicEnv: EpicEnvironment;
  certificateFileContent: Scalars['String'];
}>;


export type UploadEpicHl7ClientCertificateMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly uploadEpicHL7ClientCertificate?: Maybe<(
    { readonly __typename?: 'HL7CertificateUploadResultType' }
    & Pick<Hl7CertificateUploadResultType, 'error' | 'status' | 'thumbprint'>
  )> }
);

export type DownloadEpicHl7ClientCertificateQueryVariables = Exact<{
  epicEnv: EpicEnvironment;
}>;


export type DownloadEpicHl7ClientCertificateQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'downloadEpicHL7ClientCertificate'>
);

export type GetCernerAdminPrivacyConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCernerAdminPrivacyConsentQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getCernerAdminPrivacyConsent'>
);

export type GetCernerAttendeePrivacyConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCernerAttendeePrivacyConsentQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getCernerAttendeePrivacyConsent'>
);

export type GetCernerIntegrationRecordSettingsQueryVariables = Exact<{
  externalOrgId: Scalars['String'];
}>;


export type GetCernerIntegrationRecordSettingsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getCernerIntegrationRecordSettings?: Maybe<(
    { readonly __typename?: 'CernerIntegrationRecordSettingsType' }
    & Pick<CernerIntegrationRecordSettingsType, 'providerClientId' | 'providerLaunchUrl'>
  )> }
);

export type GetCernerNotificationTemplatesQueryVariables = Exact<{
  cernerEnv: CernerEnvironment;
}>;


export type GetCernerNotificationTemplatesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getCernerNotificationTemplates?: Maybe<(
    { readonly __typename?: 'NotificationTemplatesType' }
    & Pick<NotificationTemplatesType, 'confirmationNotificationTemplate' | 'reminderNotificationTemplate'>
  )> }
);

export type GetCernerTenantConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCernerTenantConfigsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getCernerTenantConfigs?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'CernerTenantConfigType' }
    & Pick<CernerTenantConfigType, 'cernerEnv' | 'externalOrgId' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId' | 'm365TenantName' | 'phoneNumber' | 'timeZone'>
  )>>> }
);

export type GetEhrVendorContextsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEhrVendorContextsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEhrVendorContexts?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'VendorContextType' }
    & Pick<VendorContextType, 'ehrVendor' | 'isCustomerAnalyst'>
  )>>> }
);

export type GetEpicAdminPrivacyConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpicAdminPrivacyConsentQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getEpicAdminPrivacyConsent'>
);

export type GetEpicAttendeePrivacyConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpicAttendeePrivacyConsentQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getEpicAttendeePrivacyConsent'>
);

export type GetEpicAuthorizeUrlStandaloneQueryVariables = Exact<{
  epicEnv?: Maybe<Scalars['String']>;
  issuerUrl: Scalars['String'];
}>;


export type GetEpicAuthorizeUrlStandaloneQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getEpicAuthorizeUrlStandalone'>
);

export type GetEpicHl7ClientCertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpicHl7ClientCertificatesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicHL7ClientCertificates?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'EpicHL7ClientCertificateType' }
    & Pick<EpicHl7ClientCertificateType, 'certificateThumbprint' | 'epicEnv' | 'externalSource'>
  )>>> }
);

export type GetEpicIntegrationRecordSettingsQueryVariables = Exact<{
  externalOrgId: Scalars['String'];
}>;


export type GetEpicIntegrationRecordSettingsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicIntegrationRecordSettings?: Maybe<(
    { readonly __typename?: 'EpicIntegrationRecordSettingsType' }
    & Pick<EpicIntegrationRecordSettingsType, 'patientClientId' | 'patientContextToken' | 'patientLaunchUrl' | 'deviceTesterContextToken' | 'providerClientId' | 'providerContextToken' | 'providerLaunchUrl' | 'directJoinLaunchUrl' | 'directJoinLaunchShortUrl' | 'directJoinClientId' | 'directJoinContextToken' | 'hL7EventPostUrl'>
  )> }
);

export type GetEpicNotificationTemplatesQueryVariables = Exact<{
  externalOrgId: Scalars['String'];
  epicEnv: EpicEnvironment;
}>;


export type GetEpicNotificationTemplatesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicNotificationTemplates?: Maybe<(
    { readonly __typename?: 'NotificationTemplatesType' }
    & Pick<NotificationTemplatesType, 'confirmationNotificationTemplate' | 'reminderNotificationTemplate'>
  )> }
);

export type GetEpicPatientLaunchMeetingLobbyContinueUrlQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetEpicPatientLaunchMeetingLobbyContinueUrlQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getEpicPatientLaunchMeetingLobbyContinueUrl'>
);

export type GetEpicSmsNotificationSettingsQueryVariables = Exact<{
  externalOrgId: Scalars['String'];
}>;


export type GetEpicSmsNotificationSettingsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicSMSNotificationSettings?: Maybe<(
    { readonly __typename?: 'NotificationSettingType' }
    & Pick<NotificationSettingType, 'externalOrgId' | 'notificationTypes' | 'notifyAheadTimeIntervals'>
  )> }
);

export type GetEpicTenantConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpicTenantConfigsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicTenantConfigs?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'EpicTenantConfigType' }
    & Pick<EpicTenantConfigType, 'externalOrgId' | 'isApproved' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId' | 'm365TenantName' | 'epicAdminIds' | 'epicEnv' | 'phoneNumber' | 'timeZone'>
  )>>> }
);

export type GetEpicTenantConfigsNonAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpicTenantConfigsNonAdminQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicTenantConfigsNonAdmin?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'EpicTenantConfigType' }
    & Pick<EpicTenantConfigType, 'externalOrgId' | 'isApproved' | 'issuerUrl' | 'fHIRURLNickname' | 'm365TenantId' | 'm365TenantName' | 'epicAdminIds' | 'epicEnv' | 'phoneNumber' | 'timeZone'>
  )>>> }
);

export type GetEpicUserContextsQueryVariables = Exact<{
  externalOrgIds?: Maybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type GetEpicUserContextsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getEpicUserContexts?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'EpicUserContextType' }
    & Pick<EpicUserContextType, 'isAdmin' | 'userName'>
  ) | (
    { readonly __typename?: 'GetEpicUserContextsException' }
    & Pick<GetEpicUserContextsException, 'error'>
  ) | (
    { readonly __typename?: 'EpicServerErrorException' }
    & { readonly epicError?: Maybe<(
      { readonly __typename?: 'EpicErrorType' }
      & Pick<EpicErrorType, 'errorMessage' | 'statusCode' | 'isRetryable'>
    )> }
  )>>> }
);

export type GetTenantPhoneNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantPhoneNumbersQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getTenantPhoneNumbers?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'PhoneNumberSettingType' }
    & Pick<PhoneNumberSettingType, 'countryCode' | 'createdBy' | 'createdDateTime' | 'linkedEhrVendors' | 'phoneNumber' | 'provisionState'>
  )>>> }
);

export type GetTimeZoneQueryVariables = Exact<{
  externalSource: Scalars['String'];
  externalOrgId: Scalars['String'];
}>;


export type GetTimeZoneQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getTimeZone'>
);

export type GetTimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeZonesQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getTimeZones?: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'TimeZoneInfoType' }
    & Pick<TimeZoneInfoType, 'displayName' | 'id'>
  )>>> }
);

export type GetUserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserContextQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getUserContext?: Maybe<(
    { readonly __typename?: 'UserContextType' }
    & Pick<UserContextType, 'isTenantAdmin' | 'locale' | 'regionalEndpoint' | 'tenantName' | 'timeZone'>
  )> }
);

export type ValidateIssuerUrlQueryVariables = Exact<{
  issuerUrl: Scalars['String'];
  externalOrgId?: Maybe<Scalars['String']>;
  env: Scalars['String'];
}>;


export type ValidateIssuerUrlQuery = (
  { readonly __typename?: 'Query' }
  & { readonly validateIssuerUrl?: Maybe<(
    { readonly __typename?: 'ValidationResultType' }
    & Pick<ValidationResultType, 'isValid' | 'reason' | 'errorMessage'>
  )> }
);

export type GetAriaIngestionKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAriaIngestionKeyQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getAriaIngestionKey'>
);


export const ApproveEpicTenantConfigDocument = gql`
    mutation ApproveEpicTenantConfig($externalOrgId: String!) {
  approveEpicTenantConfig_v2(externalOrgId: $externalOrgId) {
    ... on ApproveEpicTenantConfigException {
      error
    }
    ... on EpicTenantConfigType {
      epicAdminIds
      epicEnv
      externalOrgId
      isApproved
      issuerUrl
      fHIRURLNickname
      m365TenantId
      m365TenantName
    }
    ... on EpicServerErrorException {
      epicError: error {
        errorMessage
        statusCode
        isRetryable
      }
    }
  }
}
    `;
export type ApproveEpicTenantConfigMutationFn = ApolloReactCommon.MutationFunction<ApproveEpicTenantConfigMutation, ApproveEpicTenantConfigMutationVariables>;

/**
 * __useApproveEpicTenantConfigMutation__
 *
 * To run a mutation, you first call `useApproveEpicTenantConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveEpicTenantConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveEpicTenantConfigMutation, { data, loading, error }] = useApproveEpicTenantConfigMutation({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useApproveEpicTenantConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveEpicTenantConfigMutation, ApproveEpicTenantConfigMutationVariables>) {
        return ApolloReactHooks.useMutation<ApproveEpicTenantConfigMutation, ApproveEpicTenantConfigMutationVariables>(ApproveEpicTenantConfigDocument, baseOptions);
      }
export type ApproveEpicTenantConfigMutationHookResult = ReturnType<typeof useApproveEpicTenantConfigMutation>;
export type ApproveEpicTenantConfigMutationResult = ApolloReactCommon.MutationResult<ApproveEpicTenantConfigMutation>;
export type ApproveEpicTenantConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<ApproveEpicTenantConfigMutation, ApproveEpicTenantConfigMutationVariables>;
export const CreateCernerTenantConfigDocument = gql`
    mutation CreateCernerTenantConfig($issuerUrl: String!, $fHIRURLNickname: String, $cernerEnv: CernerEnvironment!) {
  createCernerTenantConfig(
    issuerUrl: $issuerUrl
    fHIRURLNickname: $fHIRURLNickname
    cernerEnv: $cernerEnv
  ) {
    ... on CreateTenantConfigException {
      error
    }
    ... on CernerTenantConfigType {
      externalOrgId
      issuerUrl
      fHIRURLNickname
      m365TenantId
      m365TenantName
      cernerEnv
    }
  }
}
    `;
export type CreateCernerTenantConfigMutationFn = ApolloReactCommon.MutationFunction<CreateCernerTenantConfigMutation, CreateCernerTenantConfigMutationVariables>;

/**
 * __useCreateCernerTenantConfigMutation__
 *
 * To run a mutation, you first call `useCreateCernerTenantConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCernerTenantConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCernerTenantConfigMutation, { data, loading, error }] = useCreateCernerTenantConfigMutation({
 *   variables: {
 *      issuerUrl: // value for 'issuerUrl'
 *      fHIRURLNickname: // value for 'fHIRURLNickname'
 *      cernerEnv: // value for 'cernerEnv'
 *   },
 * });
 */
export function useCreateCernerTenantConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCernerTenantConfigMutation, CreateCernerTenantConfigMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCernerTenantConfigMutation, CreateCernerTenantConfigMutationVariables>(CreateCernerTenantConfigDocument, baseOptions);
      }
export type CreateCernerTenantConfigMutationHookResult = ReturnType<typeof useCreateCernerTenantConfigMutation>;
export type CreateCernerTenantConfigMutationResult = ApolloReactCommon.MutationResult<CreateCernerTenantConfigMutation>;
export type CreateCernerTenantConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCernerTenantConfigMutation, CreateCernerTenantConfigMutationVariables>;
export const CreateTenantConfigDocument = gql`
    mutation CreateTenantConfig($issuerUrl: String!, $fHIRURLNickname: String, $epicAdminIds: [String!]!, $epicEnv: EpicEnvironment!) {
  createEpicTenantConfig_v2(
    issuerUrl: $issuerUrl
    fHIRURLNickname: $fHIRURLNickname
    epicAdminIds: $epicAdminIds
    epicEnv: $epicEnv
  ) {
    ... on CreateEpicTenantConfigException {
      error
    }
    ... on EpicTenantConfigType {
      externalOrgId
      isApproved
      issuerUrl
      fHIRURLNickname
      m365TenantId
      m365TenantName
      epicAdminIds
      epicEnv
    }
    ... on EpicServerErrorException {
      epicError: error {
        errorMessage
        statusCode
        isRetryable
      }
    }
  }
}
    `;
export type CreateTenantConfigMutationFn = ApolloReactCommon.MutationFunction<CreateTenantConfigMutation, CreateTenantConfigMutationVariables>;

/**
 * __useCreateTenantConfigMutation__
 *
 * To run a mutation, you first call `useCreateTenantConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantConfigMutation, { data, loading, error }] = useCreateTenantConfigMutation({
 *   variables: {
 *      issuerUrl: // value for 'issuerUrl'
 *      fHIRURLNickname: // value for 'fHIRURLNickname'
 *      epicAdminIds: // value for 'epicAdminIds'
 *      epicEnv: // value for 'epicEnv'
 *   },
 * });
 */
export function useCreateTenantConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTenantConfigMutation, CreateTenantConfigMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTenantConfigMutation, CreateTenantConfigMutationVariables>(CreateTenantConfigDocument, baseOptions);
      }
export type CreateTenantConfigMutationHookResult = ReturnType<typeof useCreateTenantConfigMutation>;
export type CreateTenantConfigMutationResult = ApolloReactCommon.MutationResult<CreateTenantConfigMutation>;
export type CreateTenantConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTenantConfigMutation, CreateTenantConfigMutationVariables>;
export const CreateTenantPhoneNumberDocument = gql`
    mutation CreateTenantPhoneNumber($countryCode: CountryCode!) {
  createTenantPhoneNumber(countryCode: $countryCode) {
    countryCode
    createdBy
    createdDateTime
    linkedEhrVendors
    phoneNumber
    provisionState
  }
}
    `;
export type CreateTenantPhoneNumberMutationFn = ApolloReactCommon.MutationFunction<CreateTenantPhoneNumberMutation, CreateTenantPhoneNumberMutationVariables>;

/**
 * __useCreateTenantPhoneNumberMutation__
 *
 * To run a mutation, you first call `useCreateTenantPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantPhoneNumberMutation, { data, loading, error }] = useCreateTenantPhoneNumberMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useCreateTenantPhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTenantPhoneNumberMutation, CreateTenantPhoneNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTenantPhoneNumberMutation, CreateTenantPhoneNumberMutationVariables>(CreateTenantPhoneNumberDocument, baseOptions);
      }
export type CreateTenantPhoneNumberMutationHookResult = ReturnType<typeof useCreateTenantPhoneNumberMutation>;
export type CreateTenantPhoneNumberMutationResult = ApolloReactCommon.MutationResult<CreateTenantPhoneNumberMutation>;
export type CreateTenantPhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTenantPhoneNumberMutation, CreateTenantPhoneNumberMutationVariables>;
export const DeleteCernerTenantConfigDocument = gql`
    mutation DeleteCernerTenantConfig($externalOrgId: String!) {
  deleteCernerTenantConfig(externalOrgId: $externalOrgId)
}
    `;
export type DeleteCernerTenantConfigMutationFn = ApolloReactCommon.MutationFunction<DeleteCernerTenantConfigMutation, DeleteCernerTenantConfigMutationVariables>;

/**
 * __useDeleteCernerTenantConfigMutation__
 *
 * To run a mutation, you first call `useDeleteCernerTenantConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCernerTenantConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCernerTenantConfigMutation, { data, loading, error }] = useDeleteCernerTenantConfigMutation({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useDeleteCernerTenantConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCernerTenantConfigMutation, DeleteCernerTenantConfigMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCernerTenantConfigMutation, DeleteCernerTenantConfigMutationVariables>(DeleteCernerTenantConfigDocument, baseOptions);
      }
export type DeleteCernerTenantConfigMutationHookResult = ReturnType<typeof useDeleteCernerTenantConfigMutation>;
export type DeleteCernerTenantConfigMutationResult = ApolloReactCommon.MutationResult<DeleteCernerTenantConfigMutation>;
export type DeleteCernerTenantConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCernerTenantConfigMutation, DeleteCernerTenantConfigMutationVariables>;
export const DeleteEpicHl7ClientCertificateDocument = gql`
    mutation DeleteEpicHL7ClientCertificate($epicEnv: EpicEnvironment!) {
  deleteEpicHL7ClientCertificate(epicEnv: $epicEnv)
}
    `;
export type DeleteEpicHl7ClientCertificateMutationFn = ApolloReactCommon.MutationFunction<DeleteEpicHl7ClientCertificateMutation, DeleteEpicHl7ClientCertificateMutationVariables>;

/**
 * __useDeleteEpicHl7ClientCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteEpicHl7ClientCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpicHl7ClientCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpicHl7ClientCertificateMutation, { data, loading, error }] = useDeleteEpicHl7ClientCertificateMutation({
 *   variables: {
 *      epicEnv: // value for 'epicEnv'
 *   },
 * });
 */
export function useDeleteEpicHl7ClientCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEpicHl7ClientCertificateMutation, DeleteEpicHl7ClientCertificateMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEpicHl7ClientCertificateMutation, DeleteEpicHl7ClientCertificateMutationVariables>(DeleteEpicHl7ClientCertificateDocument, baseOptions);
      }
export type DeleteEpicHl7ClientCertificateMutationHookResult = ReturnType<typeof useDeleteEpicHl7ClientCertificateMutation>;
export type DeleteEpicHl7ClientCertificateMutationResult = ApolloReactCommon.MutationResult<DeleteEpicHl7ClientCertificateMutation>;
export type DeleteEpicHl7ClientCertificateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteEpicHl7ClientCertificateMutation, DeleteEpicHl7ClientCertificateMutationVariables>;
export const DeleteEpicTenantConfigDocument = gql`
    mutation DeleteEpicTenantConfig($externalOrgId: String!) {
  deleteEpicTenantConfig(externalOrgId: $externalOrgId)
}
    `;
export type DeleteEpicTenantConfigMutationFn = ApolloReactCommon.MutationFunction<DeleteEpicTenantConfigMutation, DeleteEpicTenantConfigMutationVariables>;

/**
 * __useDeleteEpicTenantConfigMutation__
 *
 * To run a mutation, you first call `useDeleteEpicTenantConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpicTenantConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpicTenantConfigMutation, { data, loading, error }] = useDeleteEpicTenantConfigMutation({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useDeleteEpicTenantConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEpicTenantConfigMutation, DeleteEpicTenantConfigMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEpicTenantConfigMutation, DeleteEpicTenantConfigMutationVariables>(DeleteEpicTenantConfigDocument, baseOptions);
      }
export type DeleteEpicTenantConfigMutationHookResult = ReturnType<typeof useDeleteEpicTenantConfigMutation>;
export type DeleteEpicTenantConfigMutationResult = ApolloReactCommon.MutationResult<DeleteEpicTenantConfigMutation>;
export type DeleteEpicTenantConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteEpicTenantConfigMutation, DeleteEpicTenantConfigMutationVariables>;
export const DeleteTenantPhoneNumberDocument = gql`
    mutation DeleteTenantPhoneNumber($phoneNumber: String!) {
  deleteTenantPhoneNumber(phoneNumber: $phoneNumber)
}
    `;
export type DeleteTenantPhoneNumberMutationFn = ApolloReactCommon.MutationFunction<DeleteTenantPhoneNumberMutation, DeleteTenantPhoneNumberMutationVariables>;

/**
 * __useDeleteTenantPhoneNumberMutation__
 *
 * To run a mutation, you first call `useDeleteTenantPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantPhoneNumberMutation, { data, loading, error }] = useDeleteTenantPhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useDeleteTenantPhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTenantPhoneNumberMutation, DeleteTenantPhoneNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTenantPhoneNumberMutation, DeleteTenantPhoneNumberMutationVariables>(DeleteTenantPhoneNumberDocument, baseOptions);
      }
export type DeleteTenantPhoneNumberMutationHookResult = ReturnType<typeof useDeleteTenantPhoneNumberMutation>;
export type DeleteTenantPhoneNumberMutationResult = ApolloReactCommon.MutationResult<DeleteTenantPhoneNumberMutation>;
export type DeleteTenantPhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTenantPhoneNumberMutation, DeleteTenantPhoneNumberMutationVariables>;
export const LinkTenantPhoneNumberDocument = gql`
    mutation LinkTenantPhoneNumber($externalSource: String!, $externalOrgId: String!, $phoneNumber: String!) {
  linkTenantPhoneNumber(
    externalSource: $externalSource
    externalOrgId: $externalOrgId
    phoneNumber: $phoneNumber
  )
}
    `;
export type LinkTenantPhoneNumberMutationFn = ApolloReactCommon.MutationFunction<LinkTenantPhoneNumberMutation, LinkTenantPhoneNumberMutationVariables>;

/**
 * __useLinkTenantPhoneNumberMutation__
 *
 * To run a mutation, you first call `useLinkTenantPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTenantPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTenantPhoneNumberMutation, { data, loading, error }] = useLinkTenantPhoneNumberMutation({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *      externalOrgId: // value for 'externalOrgId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useLinkTenantPhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkTenantPhoneNumberMutation, LinkTenantPhoneNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<LinkTenantPhoneNumberMutation, LinkTenantPhoneNumberMutationVariables>(LinkTenantPhoneNumberDocument, baseOptions);
      }
export type LinkTenantPhoneNumberMutationHookResult = ReturnType<typeof useLinkTenantPhoneNumberMutation>;
export type LinkTenantPhoneNumberMutationResult = ApolloReactCommon.MutationResult<LinkTenantPhoneNumberMutation>;
export type LinkTenantPhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkTenantPhoneNumberMutation, LinkTenantPhoneNumberMutationVariables>;
export const SetEpicSmsNotificationSettingsDocument = gql`
    mutation SetEpicSMSNotificationSettings($externalOrgId: String!, $notificationTypes: [Notification]!, $notifyAheadTimeIntervals: [NotifyAheadTimeInterval] = null) {
  setEpicSMSNotificationSettings(
    externalOrgId: $externalOrgId
    notificationTypes: $notificationTypes
    notifyAheadTimeIntervals: $notifyAheadTimeIntervals
  ) {
    externalOrgId
    notificationTypes
    notifyAheadTimeIntervals
  }
}
    `;
export type SetEpicSmsNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<SetEpicSmsNotificationSettingsMutation, SetEpicSmsNotificationSettingsMutationVariables>;

/**
 * __useSetEpicSmsNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useSetEpicSmsNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEpicSmsNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEpicSmsNotificationSettingsMutation, { data, loading, error }] = useSetEpicSmsNotificationSettingsMutation({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *      notificationTypes: // value for 'notificationTypes'
 *      notifyAheadTimeIntervals: // value for 'notifyAheadTimeIntervals'
 *   },
 * });
 */
export function useSetEpicSmsNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEpicSmsNotificationSettingsMutation, SetEpicSmsNotificationSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<SetEpicSmsNotificationSettingsMutation, SetEpicSmsNotificationSettingsMutationVariables>(SetEpicSmsNotificationSettingsDocument, baseOptions);
      }
export type SetEpicSmsNotificationSettingsMutationHookResult = ReturnType<typeof useSetEpicSmsNotificationSettingsMutation>;
export type SetEpicSmsNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<SetEpicSmsNotificationSettingsMutation>;
export type SetEpicSmsNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetEpicSmsNotificationSettingsMutation, SetEpicSmsNotificationSettingsMutationVariables>;
export const UnlinkTenantPhoneNumberDocument = gql`
    mutation UnlinkTenantPhoneNumber($externalSource: String!, $externalOrgId: String!) {
  unlinkTenantPhoneNumber(
    externalSource: $externalSource
    externalOrgId: $externalOrgId
  )
}
    `;
export type UnlinkTenantPhoneNumberMutationFn = ApolloReactCommon.MutationFunction<UnlinkTenantPhoneNumberMutation, UnlinkTenantPhoneNumberMutationVariables>;

/**
 * __useUnlinkTenantPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUnlinkTenantPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTenantPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTenantPhoneNumberMutation, { data, loading, error }] = useUnlinkTenantPhoneNumberMutation({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useUnlinkTenantPhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkTenantPhoneNumberMutation, UnlinkTenantPhoneNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<UnlinkTenantPhoneNumberMutation, UnlinkTenantPhoneNumberMutationVariables>(UnlinkTenantPhoneNumberDocument, baseOptions);
      }
export type UnlinkTenantPhoneNumberMutationHookResult = ReturnType<typeof useUnlinkTenantPhoneNumberMutation>;
export type UnlinkTenantPhoneNumberMutationResult = ApolloReactCommon.MutationResult<UnlinkTenantPhoneNumberMutation>;
export type UnlinkTenantPhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkTenantPhoneNumberMutation, UnlinkTenantPhoneNumberMutationVariables>;
export const UpdateCernerAdminPrivacyConsentDocument = gql`
    mutation UpdateCernerAdminPrivacyConsent($privacyConsentAccepted: Boolean!) {
  updateCernerAdminPrivacyConsent(privacyConsentAccepted: $privacyConsentAccepted)
}
    `;
export type UpdateCernerAdminPrivacyConsentMutationFn = ApolloReactCommon.MutationFunction<UpdateCernerAdminPrivacyConsentMutation, UpdateCernerAdminPrivacyConsentMutationVariables>;

/**
 * __useUpdateCernerAdminPrivacyConsentMutation__
 *
 * To run a mutation, you first call `useUpdateCernerAdminPrivacyConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCernerAdminPrivacyConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCernerAdminPrivacyConsentMutation, { data, loading, error }] = useUpdateCernerAdminPrivacyConsentMutation({
 *   variables: {
 *      privacyConsentAccepted: // value for 'privacyConsentAccepted'
 *   },
 * });
 */
export function useUpdateCernerAdminPrivacyConsentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCernerAdminPrivacyConsentMutation, UpdateCernerAdminPrivacyConsentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCernerAdminPrivacyConsentMutation, UpdateCernerAdminPrivacyConsentMutationVariables>(UpdateCernerAdminPrivacyConsentDocument, baseOptions);
      }
export type UpdateCernerAdminPrivacyConsentMutationHookResult = ReturnType<typeof useUpdateCernerAdminPrivacyConsentMutation>;
export type UpdateCernerAdminPrivacyConsentMutationResult = ApolloReactCommon.MutationResult<UpdateCernerAdminPrivacyConsentMutation>;
export type UpdateCernerAdminPrivacyConsentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCernerAdminPrivacyConsentMutation, UpdateCernerAdminPrivacyConsentMutationVariables>;
export const UpdateCernerAttendeePrivacyConsentDocument = gql`
    mutation UpdateCernerAttendeePrivacyConsent($privacyConsentAccepted: Boolean!) {
  updateCernerAttendeePrivacyConsent(
    privacyConsentAccepted: $privacyConsentAccepted
  )
}
    `;
export type UpdateCernerAttendeePrivacyConsentMutationFn = ApolloReactCommon.MutationFunction<UpdateCernerAttendeePrivacyConsentMutation, UpdateCernerAttendeePrivacyConsentMutationVariables>;

/**
 * __useUpdateCernerAttendeePrivacyConsentMutation__
 *
 * To run a mutation, you first call `useUpdateCernerAttendeePrivacyConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCernerAttendeePrivacyConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCernerAttendeePrivacyConsentMutation, { data, loading, error }] = useUpdateCernerAttendeePrivacyConsentMutation({
 *   variables: {
 *      privacyConsentAccepted: // value for 'privacyConsentAccepted'
 *   },
 * });
 */
export function useUpdateCernerAttendeePrivacyConsentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCernerAttendeePrivacyConsentMutation, UpdateCernerAttendeePrivacyConsentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCernerAttendeePrivacyConsentMutation, UpdateCernerAttendeePrivacyConsentMutationVariables>(UpdateCernerAttendeePrivacyConsentDocument, baseOptions);
      }
export type UpdateCernerAttendeePrivacyConsentMutationHookResult = ReturnType<typeof useUpdateCernerAttendeePrivacyConsentMutation>;
export type UpdateCernerAttendeePrivacyConsentMutationResult = ApolloReactCommon.MutationResult<UpdateCernerAttendeePrivacyConsentMutation>;
export type UpdateCernerAttendeePrivacyConsentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCernerAttendeePrivacyConsentMutation, UpdateCernerAttendeePrivacyConsentMutationVariables>;
export const UpdateEpicAdminPrivacyConsentDocument = gql`
    mutation UpdateEpicAdminPrivacyConsent($privacyConsentAccepted: Boolean!) {
  updateEpicAdminPrivacyConsent(privacyConsentAccepted: $privacyConsentAccepted)
}
    `;
export type UpdateEpicAdminPrivacyConsentMutationFn = ApolloReactCommon.MutationFunction<UpdateEpicAdminPrivacyConsentMutation, UpdateEpicAdminPrivacyConsentMutationVariables>;

/**
 * __useUpdateEpicAdminPrivacyConsentMutation__
 *
 * To run a mutation, you first call `useUpdateEpicAdminPrivacyConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpicAdminPrivacyConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpicAdminPrivacyConsentMutation, { data, loading, error }] = useUpdateEpicAdminPrivacyConsentMutation({
 *   variables: {
 *      privacyConsentAccepted: // value for 'privacyConsentAccepted'
 *   },
 * });
 */
export function useUpdateEpicAdminPrivacyConsentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEpicAdminPrivacyConsentMutation, UpdateEpicAdminPrivacyConsentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEpicAdminPrivacyConsentMutation, UpdateEpicAdminPrivacyConsentMutationVariables>(UpdateEpicAdminPrivacyConsentDocument, baseOptions);
      }
export type UpdateEpicAdminPrivacyConsentMutationHookResult = ReturnType<typeof useUpdateEpicAdminPrivacyConsentMutation>;
export type UpdateEpicAdminPrivacyConsentMutationResult = ApolloReactCommon.MutationResult<UpdateEpicAdminPrivacyConsentMutation>;
export type UpdateEpicAdminPrivacyConsentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEpicAdminPrivacyConsentMutation, UpdateEpicAdminPrivacyConsentMutationVariables>;
export const UpdateEpicAttendeePrivacyConsentDocument = gql`
    mutation UpdateEpicAttendeePrivacyConsent($privacyConsentAccepted: Boolean!) {
  updateEpicAttendeePrivacyConsent(
    privacyConsentAccepted: $privacyConsentAccepted
  )
}
    `;
export type UpdateEpicAttendeePrivacyConsentMutationFn = ApolloReactCommon.MutationFunction<UpdateEpicAttendeePrivacyConsentMutation, UpdateEpicAttendeePrivacyConsentMutationVariables>;

/**
 * __useUpdateEpicAttendeePrivacyConsentMutation__
 *
 * To run a mutation, you first call `useUpdateEpicAttendeePrivacyConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpicAttendeePrivacyConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpicAttendeePrivacyConsentMutation, { data, loading, error }] = useUpdateEpicAttendeePrivacyConsentMutation({
 *   variables: {
 *      privacyConsentAccepted: // value for 'privacyConsentAccepted'
 *   },
 * });
 */
export function useUpdateEpicAttendeePrivacyConsentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEpicAttendeePrivacyConsentMutation, UpdateEpicAttendeePrivacyConsentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEpicAttendeePrivacyConsentMutation, UpdateEpicAttendeePrivacyConsentMutationVariables>(UpdateEpicAttendeePrivacyConsentDocument, baseOptions);
      }
export type UpdateEpicAttendeePrivacyConsentMutationHookResult = ReturnType<typeof useUpdateEpicAttendeePrivacyConsentMutation>;
export type UpdateEpicAttendeePrivacyConsentMutationResult = ApolloReactCommon.MutationResult<UpdateEpicAttendeePrivacyConsentMutation>;
export type UpdateEpicAttendeePrivacyConsentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEpicAttendeePrivacyConsentMutation, UpdateEpicAttendeePrivacyConsentMutationVariables>;
export const UpdateEpicTenantConfigDocument = gql`
    mutation UpdateEpicTenantConfig($externalOrgId: String!, $issuerUrl: String = null, $fHIRURLNickname: String = null, $epicAdminIds: [String!] = null) {
  updateEpicTenantConfig(
    externalOrgId: $externalOrgId
    issuerUrl: $issuerUrl
    fHIRURLNickname: $fHIRURLNickname
    epicAdminIds: $epicAdminIds
  ) {
    externalOrgId
    isApproved
    issuerUrl
    fHIRURLNickname
    m365TenantId
  }
}
    `;
export type UpdateEpicTenantConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateEpicTenantConfigMutation, UpdateEpicTenantConfigMutationVariables>;

/**
 * __useUpdateEpicTenantConfigMutation__
 *
 * To run a mutation, you first call `useUpdateEpicTenantConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpicTenantConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpicTenantConfigMutation, { data, loading, error }] = useUpdateEpicTenantConfigMutation({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *      issuerUrl: // value for 'issuerUrl'
 *      fHIRURLNickname: // value for 'fHIRURLNickname'
 *      epicAdminIds: // value for 'epicAdminIds'
 *   },
 * });
 */
export function useUpdateEpicTenantConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEpicTenantConfigMutation, UpdateEpicTenantConfigMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEpicTenantConfigMutation, UpdateEpicTenantConfigMutationVariables>(UpdateEpicTenantConfigDocument, baseOptions);
      }
export type UpdateEpicTenantConfigMutationHookResult = ReturnType<typeof useUpdateEpicTenantConfigMutation>;
export type UpdateEpicTenantConfigMutationResult = ApolloReactCommon.MutationResult<UpdateEpicTenantConfigMutation>;
export type UpdateEpicTenantConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEpicTenantConfigMutation, UpdateEpicTenantConfigMutationVariables>;
export const UpdateTimeZoneDocument = gql`
    mutation UpdateTimeZone($externalSource: String!, $externalOrgId: String!, $timeZoneId: String = null) {
  updateTimeZone(
    externalSource: $externalSource
    externalOrgId: $externalOrgId
    timeZoneId: $timeZoneId
  )
}
    `;
export type UpdateTimeZoneMutationFn = ApolloReactCommon.MutationFunction<UpdateTimeZoneMutation, UpdateTimeZoneMutationVariables>;

/**
 * __useUpdateTimeZoneMutation__
 *
 * To run a mutation, you first call `useUpdateTimeZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeZoneMutation, { data, loading, error }] = useUpdateTimeZoneMutation({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *      externalOrgId: // value for 'externalOrgId'
 *      timeZoneId: // value for 'timeZoneId'
 *   },
 * });
 */
export function useUpdateTimeZoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeZoneMutation, UpdateTimeZoneMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTimeZoneMutation, UpdateTimeZoneMutationVariables>(UpdateTimeZoneDocument, baseOptions);
      }
export type UpdateTimeZoneMutationHookResult = ReturnType<typeof useUpdateTimeZoneMutation>;
export type UpdateTimeZoneMutationResult = ApolloReactCommon.MutationResult<UpdateTimeZoneMutation>;
export type UpdateTimeZoneMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTimeZoneMutation, UpdateTimeZoneMutationVariables>;
export const UploadEpicHl7ClientCertificateDocument = gql`
    mutation UploadEpicHL7ClientCertificate($epicEnv: EpicEnvironment!, $certificateFileContent: String!) {
  uploadEpicHL7ClientCertificate(
    epicEnv: $epicEnv
    certificateFileContent: $certificateFileContent
  ) {
    error
    status
    thumbprint
  }
}
    `;
export type UploadEpicHl7ClientCertificateMutationFn = ApolloReactCommon.MutationFunction<UploadEpicHl7ClientCertificateMutation, UploadEpicHl7ClientCertificateMutationVariables>;

/**
 * __useUploadEpicHl7ClientCertificateMutation__
 *
 * To run a mutation, you first call `useUploadEpicHl7ClientCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEpicHl7ClientCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEpicHl7ClientCertificateMutation, { data, loading, error }] = useUploadEpicHl7ClientCertificateMutation({
 *   variables: {
 *      epicEnv: // value for 'epicEnv'
 *      certificateFileContent: // value for 'certificateFileContent'
 *   },
 * });
 */
export function useUploadEpicHl7ClientCertificateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadEpicHl7ClientCertificateMutation, UploadEpicHl7ClientCertificateMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadEpicHl7ClientCertificateMutation, UploadEpicHl7ClientCertificateMutationVariables>(UploadEpicHl7ClientCertificateDocument, baseOptions);
      }
export type UploadEpicHl7ClientCertificateMutationHookResult = ReturnType<typeof useUploadEpicHl7ClientCertificateMutation>;
export type UploadEpicHl7ClientCertificateMutationResult = ApolloReactCommon.MutationResult<UploadEpicHl7ClientCertificateMutation>;
export type UploadEpicHl7ClientCertificateMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadEpicHl7ClientCertificateMutation, UploadEpicHl7ClientCertificateMutationVariables>;
export const DownloadEpicHl7ClientCertificateDocument = gql`
    query DownloadEpicHL7ClientCertificate($epicEnv: EpicEnvironment!) {
  downloadEpicHL7ClientCertificate(epicEnv: $epicEnv)
}
    `;

/**
 * __useDownloadEpicHl7ClientCertificateQuery__
 *
 * To run a query within a React component, call `useDownloadEpicHl7ClientCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadEpicHl7ClientCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadEpicHl7ClientCertificateQuery({
 *   variables: {
 *      epicEnv: // value for 'epicEnv'
 *   },
 * });
 */
export function useDownloadEpicHl7ClientCertificateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadEpicHl7ClientCertificateQuery, DownloadEpicHl7ClientCertificateQueryVariables>) {
        return ApolloReactHooks.useQuery<DownloadEpicHl7ClientCertificateQuery, DownloadEpicHl7ClientCertificateQueryVariables>(DownloadEpicHl7ClientCertificateDocument, baseOptions);
      }
export function useDownloadEpicHl7ClientCertificateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadEpicHl7ClientCertificateQuery, DownloadEpicHl7ClientCertificateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DownloadEpicHl7ClientCertificateQuery, DownloadEpicHl7ClientCertificateQueryVariables>(DownloadEpicHl7ClientCertificateDocument, baseOptions);
        }
export type DownloadEpicHl7ClientCertificateQueryHookResult = ReturnType<typeof useDownloadEpicHl7ClientCertificateQuery>;
export type DownloadEpicHl7ClientCertificateLazyQueryHookResult = ReturnType<typeof useDownloadEpicHl7ClientCertificateLazyQuery>;
export type DownloadEpicHl7ClientCertificateQueryResult = ApolloReactCommon.QueryResult<DownloadEpicHl7ClientCertificateQuery, DownloadEpicHl7ClientCertificateQueryVariables>;
export const GetCernerAdminPrivacyConsentDocument = gql`
    query GetCernerAdminPrivacyConsent {
  getCernerAdminPrivacyConsent
}
    `;

/**
 * __useGetCernerAdminPrivacyConsentQuery__
 *
 * To run a query within a React component, call `useGetCernerAdminPrivacyConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCernerAdminPrivacyConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCernerAdminPrivacyConsentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCernerAdminPrivacyConsentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCernerAdminPrivacyConsentQuery, GetCernerAdminPrivacyConsentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCernerAdminPrivacyConsentQuery, GetCernerAdminPrivacyConsentQueryVariables>(GetCernerAdminPrivacyConsentDocument, baseOptions);
      }
export function useGetCernerAdminPrivacyConsentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCernerAdminPrivacyConsentQuery, GetCernerAdminPrivacyConsentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCernerAdminPrivacyConsentQuery, GetCernerAdminPrivacyConsentQueryVariables>(GetCernerAdminPrivacyConsentDocument, baseOptions);
        }
export type GetCernerAdminPrivacyConsentQueryHookResult = ReturnType<typeof useGetCernerAdminPrivacyConsentQuery>;
export type GetCernerAdminPrivacyConsentLazyQueryHookResult = ReturnType<typeof useGetCernerAdminPrivacyConsentLazyQuery>;
export type GetCernerAdminPrivacyConsentQueryResult = ApolloReactCommon.QueryResult<GetCernerAdminPrivacyConsentQuery, GetCernerAdminPrivacyConsentQueryVariables>;
export const GetCernerAttendeePrivacyConsentDocument = gql`
    query GetCernerAttendeePrivacyConsent {
  getCernerAttendeePrivacyConsent
}
    `;

/**
 * __useGetCernerAttendeePrivacyConsentQuery__
 *
 * To run a query within a React component, call `useGetCernerAttendeePrivacyConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCernerAttendeePrivacyConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCernerAttendeePrivacyConsentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCernerAttendeePrivacyConsentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCernerAttendeePrivacyConsentQuery, GetCernerAttendeePrivacyConsentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCernerAttendeePrivacyConsentQuery, GetCernerAttendeePrivacyConsentQueryVariables>(GetCernerAttendeePrivacyConsentDocument, baseOptions);
      }
export function useGetCernerAttendeePrivacyConsentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCernerAttendeePrivacyConsentQuery, GetCernerAttendeePrivacyConsentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCernerAttendeePrivacyConsentQuery, GetCernerAttendeePrivacyConsentQueryVariables>(GetCernerAttendeePrivacyConsentDocument, baseOptions);
        }
export type GetCernerAttendeePrivacyConsentQueryHookResult = ReturnType<typeof useGetCernerAttendeePrivacyConsentQuery>;
export type GetCernerAttendeePrivacyConsentLazyQueryHookResult = ReturnType<typeof useGetCernerAttendeePrivacyConsentLazyQuery>;
export type GetCernerAttendeePrivacyConsentQueryResult = ApolloReactCommon.QueryResult<GetCernerAttendeePrivacyConsentQuery, GetCernerAttendeePrivacyConsentQueryVariables>;
export const GetCernerIntegrationRecordSettingsDocument = gql`
    query GetCernerIntegrationRecordSettings($externalOrgId: String!) {
  getCernerIntegrationRecordSettings(externalOrgId: $externalOrgId) {
    providerClientId
    providerLaunchUrl
  }
}
    `;

/**
 * __useGetCernerIntegrationRecordSettingsQuery__
 *
 * To run a query within a React component, call `useGetCernerIntegrationRecordSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCernerIntegrationRecordSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCernerIntegrationRecordSettingsQuery({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useGetCernerIntegrationRecordSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCernerIntegrationRecordSettingsQuery, GetCernerIntegrationRecordSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCernerIntegrationRecordSettingsQuery, GetCernerIntegrationRecordSettingsQueryVariables>(GetCernerIntegrationRecordSettingsDocument, baseOptions);
      }
export function useGetCernerIntegrationRecordSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCernerIntegrationRecordSettingsQuery, GetCernerIntegrationRecordSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCernerIntegrationRecordSettingsQuery, GetCernerIntegrationRecordSettingsQueryVariables>(GetCernerIntegrationRecordSettingsDocument, baseOptions);
        }
export type GetCernerIntegrationRecordSettingsQueryHookResult = ReturnType<typeof useGetCernerIntegrationRecordSettingsQuery>;
export type GetCernerIntegrationRecordSettingsLazyQueryHookResult = ReturnType<typeof useGetCernerIntegrationRecordSettingsLazyQuery>;
export type GetCernerIntegrationRecordSettingsQueryResult = ApolloReactCommon.QueryResult<GetCernerIntegrationRecordSettingsQuery, GetCernerIntegrationRecordSettingsQueryVariables>;
export const GetCernerNotificationTemplatesDocument = gql`
    query GetCernerNotificationTemplates($cernerEnv: CernerEnvironment!) {
  getCernerNotificationTemplates(cernerEnv: $cernerEnv) {
    confirmationNotificationTemplate
    reminderNotificationTemplate
  }
}
    `;

/**
 * __useGetCernerNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCernerNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCernerNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCernerNotificationTemplatesQuery({
 *   variables: {
 *      cernerEnv: // value for 'cernerEnv'
 *   },
 * });
 */
export function useGetCernerNotificationTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCernerNotificationTemplatesQuery, GetCernerNotificationTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCernerNotificationTemplatesQuery, GetCernerNotificationTemplatesQueryVariables>(GetCernerNotificationTemplatesDocument, baseOptions);
      }
export function useGetCernerNotificationTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCernerNotificationTemplatesQuery, GetCernerNotificationTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCernerNotificationTemplatesQuery, GetCernerNotificationTemplatesQueryVariables>(GetCernerNotificationTemplatesDocument, baseOptions);
        }
export type GetCernerNotificationTemplatesQueryHookResult = ReturnType<typeof useGetCernerNotificationTemplatesQuery>;
export type GetCernerNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useGetCernerNotificationTemplatesLazyQuery>;
export type GetCernerNotificationTemplatesQueryResult = ApolloReactCommon.QueryResult<GetCernerNotificationTemplatesQuery, GetCernerNotificationTemplatesQueryVariables>;
export const GetCernerTenantConfigsDocument = gql`
    query GetCernerTenantConfigs {
  getCernerTenantConfigs {
    cernerEnv
    externalOrgId
    issuerUrl
    fHIRURLNickname
    m365TenantId
    m365TenantName
    phoneNumber
    timeZone
  }
}
    `;

/**
 * __useGetCernerTenantConfigsQuery__
 *
 * To run a query within a React component, call `useGetCernerTenantConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCernerTenantConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCernerTenantConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCernerTenantConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCernerTenantConfigsQuery, GetCernerTenantConfigsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCernerTenantConfigsQuery, GetCernerTenantConfigsQueryVariables>(GetCernerTenantConfigsDocument, baseOptions);
      }
export function useGetCernerTenantConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCernerTenantConfigsQuery, GetCernerTenantConfigsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCernerTenantConfigsQuery, GetCernerTenantConfigsQueryVariables>(GetCernerTenantConfigsDocument, baseOptions);
        }
export type GetCernerTenantConfigsQueryHookResult = ReturnType<typeof useGetCernerTenantConfigsQuery>;
export type GetCernerTenantConfigsLazyQueryHookResult = ReturnType<typeof useGetCernerTenantConfigsLazyQuery>;
export type GetCernerTenantConfigsQueryResult = ApolloReactCommon.QueryResult<GetCernerTenantConfigsQuery, GetCernerTenantConfigsQueryVariables>;
export const GetEhrVendorContextsDocument = gql`
    query GetEhrVendorContexts {
  getEhrVendorContexts {
    ehrVendor
    isCustomerAnalyst
  }
}
    `;

/**
 * __useGetEhrVendorContextsQuery__
 *
 * To run a query within a React component, call `useGetEhrVendorContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEhrVendorContextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEhrVendorContextsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEhrVendorContextsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEhrVendorContextsQuery, GetEhrVendorContextsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEhrVendorContextsQuery, GetEhrVendorContextsQueryVariables>(GetEhrVendorContextsDocument, baseOptions);
      }
export function useGetEhrVendorContextsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEhrVendorContextsQuery, GetEhrVendorContextsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEhrVendorContextsQuery, GetEhrVendorContextsQueryVariables>(GetEhrVendorContextsDocument, baseOptions);
        }
export type GetEhrVendorContextsQueryHookResult = ReturnType<typeof useGetEhrVendorContextsQuery>;
export type GetEhrVendorContextsLazyQueryHookResult = ReturnType<typeof useGetEhrVendorContextsLazyQuery>;
export type GetEhrVendorContextsQueryResult = ApolloReactCommon.QueryResult<GetEhrVendorContextsQuery, GetEhrVendorContextsQueryVariables>;
export const GetEpicAdminPrivacyConsentDocument = gql`
    query GetEpicAdminPrivacyConsent {
  getEpicAdminPrivacyConsent
}
    `;

/**
 * __useGetEpicAdminPrivacyConsentQuery__
 *
 * To run a query within a React component, call `useGetEpicAdminPrivacyConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicAdminPrivacyConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicAdminPrivacyConsentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEpicAdminPrivacyConsentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEpicAdminPrivacyConsentQuery, GetEpicAdminPrivacyConsentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicAdminPrivacyConsentQuery, GetEpicAdminPrivacyConsentQueryVariables>(GetEpicAdminPrivacyConsentDocument, baseOptions);
      }
export function useGetEpicAdminPrivacyConsentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicAdminPrivacyConsentQuery, GetEpicAdminPrivacyConsentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicAdminPrivacyConsentQuery, GetEpicAdminPrivacyConsentQueryVariables>(GetEpicAdminPrivacyConsentDocument, baseOptions);
        }
export type GetEpicAdminPrivacyConsentQueryHookResult = ReturnType<typeof useGetEpicAdminPrivacyConsentQuery>;
export type GetEpicAdminPrivacyConsentLazyQueryHookResult = ReturnType<typeof useGetEpicAdminPrivacyConsentLazyQuery>;
export type GetEpicAdminPrivacyConsentQueryResult = ApolloReactCommon.QueryResult<GetEpicAdminPrivacyConsentQuery, GetEpicAdminPrivacyConsentQueryVariables>;
export const GetEpicAttendeePrivacyConsentDocument = gql`
    query GetEpicAttendeePrivacyConsent {
  getEpicAttendeePrivacyConsent
}
    `;

/**
 * __useGetEpicAttendeePrivacyConsentQuery__
 *
 * To run a query within a React component, call `useGetEpicAttendeePrivacyConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicAttendeePrivacyConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicAttendeePrivacyConsentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEpicAttendeePrivacyConsentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEpicAttendeePrivacyConsentQuery, GetEpicAttendeePrivacyConsentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicAttendeePrivacyConsentQuery, GetEpicAttendeePrivacyConsentQueryVariables>(GetEpicAttendeePrivacyConsentDocument, baseOptions);
      }
export function useGetEpicAttendeePrivacyConsentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicAttendeePrivacyConsentQuery, GetEpicAttendeePrivacyConsentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicAttendeePrivacyConsentQuery, GetEpicAttendeePrivacyConsentQueryVariables>(GetEpicAttendeePrivacyConsentDocument, baseOptions);
        }
export type GetEpicAttendeePrivacyConsentQueryHookResult = ReturnType<typeof useGetEpicAttendeePrivacyConsentQuery>;
export type GetEpicAttendeePrivacyConsentLazyQueryHookResult = ReturnType<typeof useGetEpicAttendeePrivacyConsentLazyQuery>;
export type GetEpicAttendeePrivacyConsentQueryResult = ApolloReactCommon.QueryResult<GetEpicAttendeePrivacyConsentQuery, GetEpicAttendeePrivacyConsentQueryVariables>;
export const GetEpicAuthorizeUrlStandaloneDocument = gql`
    query GetEpicAuthorizeUrlStandalone($epicEnv: String = null, $issuerUrl: String!) {
  getEpicAuthorizeUrlStandalone(epicEnv: $epicEnv, issuerUrl: $issuerUrl)
}
    `;

/**
 * __useGetEpicAuthorizeUrlStandaloneQuery__
 *
 * To run a query within a React component, call `useGetEpicAuthorizeUrlStandaloneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicAuthorizeUrlStandaloneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicAuthorizeUrlStandaloneQuery({
 *   variables: {
 *      epicEnv: // value for 'epicEnv'
 *      issuerUrl: // value for 'issuerUrl'
 *   },
 * });
 */
export function useGetEpicAuthorizeUrlStandaloneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEpicAuthorizeUrlStandaloneQuery, GetEpicAuthorizeUrlStandaloneQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicAuthorizeUrlStandaloneQuery, GetEpicAuthorizeUrlStandaloneQueryVariables>(GetEpicAuthorizeUrlStandaloneDocument, baseOptions);
      }
export function useGetEpicAuthorizeUrlStandaloneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicAuthorizeUrlStandaloneQuery, GetEpicAuthorizeUrlStandaloneQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicAuthorizeUrlStandaloneQuery, GetEpicAuthorizeUrlStandaloneQueryVariables>(GetEpicAuthorizeUrlStandaloneDocument, baseOptions);
        }
export type GetEpicAuthorizeUrlStandaloneQueryHookResult = ReturnType<typeof useGetEpicAuthorizeUrlStandaloneQuery>;
export type GetEpicAuthorizeUrlStandaloneLazyQueryHookResult = ReturnType<typeof useGetEpicAuthorizeUrlStandaloneLazyQuery>;
export type GetEpicAuthorizeUrlStandaloneQueryResult = ApolloReactCommon.QueryResult<GetEpicAuthorizeUrlStandaloneQuery, GetEpicAuthorizeUrlStandaloneQueryVariables>;
export const GetEpicHl7ClientCertificatesDocument = gql`
    query GetEpicHL7ClientCertificates {
  getEpicHL7ClientCertificates {
    certificateThumbprint
    epicEnv
    externalSource
  }
}
    `;

/**
 * __useGetEpicHl7ClientCertificatesQuery__
 *
 * To run a query within a React component, call `useGetEpicHl7ClientCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicHl7ClientCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicHl7ClientCertificatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEpicHl7ClientCertificatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEpicHl7ClientCertificatesQuery, GetEpicHl7ClientCertificatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicHl7ClientCertificatesQuery, GetEpicHl7ClientCertificatesQueryVariables>(GetEpicHl7ClientCertificatesDocument, baseOptions);
      }
export function useGetEpicHl7ClientCertificatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicHl7ClientCertificatesQuery, GetEpicHl7ClientCertificatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicHl7ClientCertificatesQuery, GetEpicHl7ClientCertificatesQueryVariables>(GetEpicHl7ClientCertificatesDocument, baseOptions);
        }
export type GetEpicHl7ClientCertificatesQueryHookResult = ReturnType<typeof useGetEpicHl7ClientCertificatesQuery>;
export type GetEpicHl7ClientCertificatesLazyQueryHookResult = ReturnType<typeof useGetEpicHl7ClientCertificatesLazyQuery>;
export type GetEpicHl7ClientCertificatesQueryResult = ApolloReactCommon.QueryResult<GetEpicHl7ClientCertificatesQuery, GetEpicHl7ClientCertificatesQueryVariables>;
export const GetEpicIntegrationRecordSettingsDocument = gql`
    query GetEpicIntegrationRecordSettings($externalOrgId: String!) {
  getEpicIntegrationRecordSettings(externalOrgId: $externalOrgId) {
    patientClientId
    patientContextToken
    patientLaunchUrl
    deviceTesterContextToken
    providerClientId
    providerContextToken
    providerLaunchUrl
    directJoinLaunchUrl
    directJoinLaunchShortUrl
    directJoinClientId
    directJoinContextToken
    hL7EventPostUrl
  }
}
    `;

/**
 * __useGetEpicIntegrationRecordSettingsQuery__
 *
 * To run a query within a React component, call `useGetEpicIntegrationRecordSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicIntegrationRecordSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicIntegrationRecordSettingsQuery({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useGetEpicIntegrationRecordSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEpicIntegrationRecordSettingsQuery, GetEpicIntegrationRecordSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicIntegrationRecordSettingsQuery, GetEpicIntegrationRecordSettingsQueryVariables>(GetEpicIntegrationRecordSettingsDocument, baseOptions);
      }
export function useGetEpicIntegrationRecordSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicIntegrationRecordSettingsQuery, GetEpicIntegrationRecordSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicIntegrationRecordSettingsQuery, GetEpicIntegrationRecordSettingsQueryVariables>(GetEpicIntegrationRecordSettingsDocument, baseOptions);
        }
export type GetEpicIntegrationRecordSettingsQueryHookResult = ReturnType<typeof useGetEpicIntegrationRecordSettingsQuery>;
export type GetEpicIntegrationRecordSettingsLazyQueryHookResult = ReturnType<typeof useGetEpicIntegrationRecordSettingsLazyQuery>;
export type GetEpicIntegrationRecordSettingsQueryResult = ApolloReactCommon.QueryResult<GetEpicIntegrationRecordSettingsQuery, GetEpicIntegrationRecordSettingsQueryVariables>;
export const GetEpicNotificationTemplatesDocument = gql`
    query GetEpicNotificationTemplates($externalOrgId: String!, $epicEnv: EpicEnvironment!) {
  getEpicNotificationTemplates(externalOrgId: $externalOrgId, epicEnv: $epicEnv) {
    confirmationNotificationTemplate
    reminderNotificationTemplate
  }
}
    `;

/**
 * __useGetEpicNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEpicNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicNotificationTemplatesQuery({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *      epicEnv: // value for 'epicEnv'
 *   },
 * });
 */
export function useGetEpicNotificationTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEpicNotificationTemplatesQuery, GetEpicNotificationTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicNotificationTemplatesQuery, GetEpicNotificationTemplatesQueryVariables>(GetEpicNotificationTemplatesDocument, baseOptions);
      }
export function useGetEpicNotificationTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicNotificationTemplatesQuery, GetEpicNotificationTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicNotificationTemplatesQuery, GetEpicNotificationTemplatesQueryVariables>(GetEpicNotificationTemplatesDocument, baseOptions);
        }
export type GetEpicNotificationTemplatesQueryHookResult = ReturnType<typeof useGetEpicNotificationTemplatesQuery>;
export type GetEpicNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useGetEpicNotificationTemplatesLazyQuery>;
export type GetEpicNotificationTemplatesQueryResult = ApolloReactCommon.QueryResult<GetEpicNotificationTemplatesQuery, GetEpicNotificationTemplatesQueryVariables>;
export const GetEpicPatientLaunchMeetingLobbyContinueUrlDocument = gql`
    query GetEpicPatientLaunchMeetingLobbyContinueUrl($sessionId: String!) {
  getEpicPatientLaunchMeetingLobbyContinueUrl(sessionId: $sessionId)
}
    `;

/**
 * __useGetEpicPatientLaunchMeetingLobbyContinueUrlQuery__
 *
 * To run a query within a React component, call `useGetEpicPatientLaunchMeetingLobbyContinueUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicPatientLaunchMeetingLobbyContinueUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicPatientLaunchMeetingLobbyContinueUrlQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetEpicPatientLaunchMeetingLobbyContinueUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEpicPatientLaunchMeetingLobbyContinueUrlQuery, GetEpicPatientLaunchMeetingLobbyContinueUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicPatientLaunchMeetingLobbyContinueUrlQuery, GetEpicPatientLaunchMeetingLobbyContinueUrlQueryVariables>(GetEpicPatientLaunchMeetingLobbyContinueUrlDocument, baseOptions);
      }
export function useGetEpicPatientLaunchMeetingLobbyContinueUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicPatientLaunchMeetingLobbyContinueUrlQuery, GetEpicPatientLaunchMeetingLobbyContinueUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicPatientLaunchMeetingLobbyContinueUrlQuery, GetEpicPatientLaunchMeetingLobbyContinueUrlQueryVariables>(GetEpicPatientLaunchMeetingLobbyContinueUrlDocument, baseOptions);
        }
export type GetEpicPatientLaunchMeetingLobbyContinueUrlQueryHookResult = ReturnType<typeof useGetEpicPatientLaunchMeetingLobbyContinueUrlQuery>;
export type GetEpicPatientLaunchMeetingLobbyContinueUrlLazyQueryHookResult = ReturnType<typeof useGetEpicPatientLaunchMeetingLobbyContinueUrlLazyQuery>;
export type GetEpicPatientLaunchMeetingLobbyContinueUrlQueryResult = ApolloReactCommon.QueryResult<GetEpicPatientLaunchMeetingLobbyContinueUrlQuery, GetEpicPatientLaunchMeetingLobbyContinueUrlQueryVariables>;
export const GetEpicSmsNotificationSettingsDocument = gql`
    query GetEpicSMSNotificationSettings($externalOrgId: String!) {
  getEpicSMSNotificationSettings(externalOrgId: $externalOrgId) {
    externalOrgId
    notificationTypes
    notifyAheadTimeIntervals
  }
}
    `;

/**
 * __useGetEpicSmsNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetEpicSmsNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicSmsNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicSmsNotificationSettingsQuery({
 *   variables: {
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useGetEpicSmsNotificationSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEpicSmsNotificationSettingsQuery, GetEpicSmsNotificationSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicSmsNotificationSettingsQuery, GetEpicSmsNotificationSettingsQueryVariables>(GetEpicSmsNotificationSettingsDocument, baseOptions);
      }
export function useGetEpicSmsNotificationSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicSmsNotificationSettingsQuery, GetEpicSmsNotificationSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicSmsNotificationSettingsQuery, GetEpicSmsNotificationSettingsQueryVariables>(GetEpicSmsNotificationSettingsDocument, baseOptions);
        }
export type GetEpicSmsNotificationSettingsQueryHookResult = ReturnType<typeof useGetEpicSmsNotificationSettingsQuery>;
export type GetEpicSmsNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetEpicSmsNotificationSettingsLazyQuery>;
export type GetEpicSmsNotificationSettingsQueryResult = ApolloReactCommon.QueryResult<GetEpicSmsNotificationSettingsQuery, GetEpicSmsNotificationSettingsQueryVariables>;
export const GetEpicTenantConfigsDocument = gql`
    query GetEpicTenantConfigs {
  getEpicTenantConfigs {
    externalOrgId
    isApproved
    issuerUrl
    fHIRURLNickname
    m365TenantId
    m365TenantName
    epicAdminIds
    epicEnv
    phoneNumber
    timeZone
  }
}
    `;

/**
 * __useGetEpicTenantConfigsQuery__
 *
 * To run a query within a React component, call `useGetEpicTenantConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicTenantConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicTenantConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEpicTenantConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEpicTenantConfigsQuery, GetEpicTenantConfigsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicTenantConfigsQuery, GetEpicTenantConfigsQueryVariables>(GetEpicTenantConfigsDocument, baseOptions);
      }
export function useGetEpicTenantConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicTenantConfigsQuery, GetEpicTenantConfigsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicTenantConfigsQuery, GetEpicTenantConfigsQueryVariables>(GetEpicTenantConfigsDocument, baseOptions);
        }
export type GetEpicTenantConfigsQueryHookResult = ReturnType<typeof useGetEpicTenantConfigsQuery>;
export type GetEpicTenantConfigsLazyQueryHookResult = ReturnType<typeof useGetEpicTenantConfigsLazyQuery>;
export type GetEpicTenantConfigsQueryResult = ApolloReactCommon.QueryResult<GetEpicTenantConfigsQuery, GetEpicTenantConfigsQueryVariables>;
export const GetEpicTenantConfigsNonAdminDocument = gql`
    query GetEpicTenantConfigsNonAdmin {
  getEpicTenantConfigsNonAdmin {
    externalOrgId
    isApproved
    issuerUrl
    fHIRURLNickname
    m365TenantId
    m365TenantName
    epicAdminIds
    epicEnv
    phoneNumber
    timeZone
  }
}
    `;

/**
 * __useGetEpicTenantConfigsNonAdminQuery__
 *
 * To run a query within a React component, call `useGetEpicTenantConfigsNonAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicTenantConfigsNonAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicTenantConfigsNonAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEpicTenantConfigsNonAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEpicTenantConfigsNonAdminQuery, GetEpicTenantConfigsNonAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicTenantConfigsNonAdminQuery, GetEpicTenantConfigsNonAdminQueryVariables>(GetEpicTenantConfigsNonAdminDocument, baseOptions);
      }
export function useGetEpicTenantConfigsNonAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicTenantConfigsNonAdminQuery, GetEpicTenantConfigsNonAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicTenantConfigsNonAdminQuery, GetEpicTenantConfigsNonAdminQueryVariables>(GetEpicTenantConfigsNonAdminDocument, baseOptions);
        }
export type GetEpicTenantConfigsNonAdminQueryHookResult = ReturnType<typeof useGetEpicTenantConfigsNonAdminQuery>;
export type GetEpicTenantConfigsNonAdminLazyQueryHookResult = ReturnType<typeof useGetEpicTenantConfigsNonAdminLazyQuery>;
export type GetEpicTenantConfigsNonAdminQueryResult = ApolloReactCommon.QueryResult<GetEpicTenantConfigsNonAdminQuery, GetEpicTenantConfigsNonAdminQueryVariables>;
export const GetEpicUserContextsDocument = gql`
    query GetEpicUserContexts($externalOrgIds: [String!]) {
  getEpicUserContexts(externalOrgIds: $externalOrgIds) {
    ... on GetEpicUserContextsException {
      error
    }
    ... on EpicUserContextType {
      isAdmin
      userName
    }
    ... on EpicServerErrorException {
      epicError: error {
        errorMessage
        statusCode
        isRetryable
      }
    }
  }
}
    `;

/**
 * __useGetEpicUserContextsQuery__
 *
 * To run a query within a React component, call `useGetEpicUserContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicUserContextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicUserContextsQuery({
 *   variables: {
 *      externalOrgIds: // value for 'externalOrgIds'
 *   },
 * });
 */
export function useGetEpicUserContextsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEpicUserContextsQuery, GetEpicUserContextsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEpicUserContextsQuery, GetEpicUserContextsQueryVariables>(GetEpicUserContextsDocument, baseOptions);
      }
export function useGetEpicUserContextsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEpicUserContextsQuery, GetEpicUserContextsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEpicUserContextsQuery, GetEpicUserContextsQueryVariables>(GetEpicUserContextsDocument, baseOptions);
        }
export type GetEpicUserContextsQueryHookResult = ReturnType<typeof useGetEpicUserContextsQuery>;
export type GetEpicUserContextsLazyQueryHookResult = ReturnType<typeof useGetEpicUserContextsLazyQuery>;
export type GetEpicUserContextsQueryResult = ApolloReactCommon.QueryResult<GetEpicUserContextsQuery, GetEpicUserContextsQueryVariables>;
export const GetTenantPhoneNumbersDocument = gql`
    query GetTenantPhoneNumbers {
  getTenantPhoneNumbers {
    countryCode
    createdBy
    createdDateTime
    linkedEhrVendors
    phoneNumber
    provisionState
  }
}
    `;

/**
 * __useGetTenantPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetTenantPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantPhoneNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantPhoneNumbersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantPhoneNumbersQuery, GetTenantPhoneNumbersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantPhoneNumbersQuery, GetTenantPhoneNumbersQueryVariables>(GetTenantPhoneNumbersDocument, baseOptions);
      }
export function useGetTenantPhoneNumbersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantPhoneNumbersQuery, GetTenantPhoneNumbersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantPhoneNumbersQuery, GetTenantPhoneNumbersQueryVariables>(GetTenantPhoneNumbersDocument, baseOptions);
        }
export type GetTenantPhoneNumbersQueryHookResult = ReturnType<typeof useGetTenantPhoneNumbersQuery>;
export type GetTenantPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetTenantPhoneNumbersLazyQuery>;
export type GetTenantPhoneNumbersQueryResult = ApolloReactCommon.QueryResult<GetTenantPhoneNumbersQuery, GetTenantPhoneNumbersQueryVariables>;
export const GetTimeZoneDocument = gql`
    query GetTimeZone($externalSource: String!, $externalOrgId: String!) {
  getTimeZone(externalSource: $externalSource, externalOrgId: $externalOrgId)
}
    `;

/**
 * __useGetTimeZoneQuery__
 *
 * To run a query within a React component, call `useGetTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZoneQuery({
 *   variables: {
 *      externalSource: // value for 'externalSource'
 *      externalOrgId: // value for 'externalOrgId'
 *   },
 * });
 */
export function useGetTimeZoneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTimeZoneQuery, GetTimeZoneQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTimeZoneQuery, GetTimeZoneQueryVariables>(GetTimeZoneDocument, baseOptions);
      }
export function useGetTimeZoneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTimeZoneQuery, GetTimeZoneQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTimeZoneQuery, GetTimeZoneQueryVariables>(GetTimeZoneDocument, baseOptions);
        }
export type GetTimeZoneQueryHookResult = ReturnType<typeof useGetTimeZoneQuery>;
export type GetTimeZoneLazyQueryHookResult = ReturnType<typeof useGetTimeZoneLazyQuery>;
export type GetTimeZoneQueryResult = ApolloReactCommon.QueryResult<GetTimeZoneQuery, GetTimeZoneQueryVariables>;
export const GetTimeZonesDocument = gql`
    query GetTimeZones {
  getTimeZones {
    displayName
    id
  }
}
    `;

/**
 * __useGetTimeZonesQuery__
 *
 * To run a query within a React component, call `useGetTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeZonesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, baseOptions);
      }
export function useGetTimeZonesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, baseOptions);
        }
export type GetTimeZonesQueryHookResult = ReturnType<typeof useGetTimeZonesQuery>;
export type GetTimeZonesLazyQueryHookResult = ReturnType<typeof useGetTimeZonesLazyQuery>;
export type GetTimeZonesQueryResult = ApolloReactCommon.QueryResult<GetTimeZonesQuery, GetTimeZonesQueryVariables>;
export const GetUserContextDocument = gql`
    query GetUserContext {
  getUserContext {
    isTenantAdmin
    locale
    regionalEndpoint
    tenantName
    timeZone
  }
}
    `;

/**
 * __useGetUserContextQuery__
 *
 * To run a query within a React component, call `useGetUserContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserContextQuery, GetUserContextQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserContextQuery, GetUserContextQueryVariables>(GetUserContextDocument, baseOptions);
      }
export function useGetUserContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserContextQuery, GetUserContextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserContextQuery, GetUserContextQueryVariables>(GetUserContextDocument, baseOptions);
        }
export type GetUserContextQueryHookResult = ReturnType<typeof useGetUserContextQuery>;
export type GetUserContextLazyQueryHookResult = ReturnType<typeof useGetUserContextLazyQuery>;
export type GetUserContextQueryResult = ApolloReactCommon.QueryResult<GetUserContextQuery, GetUserContextQueryVariables>;
export const ValidateIssuerUrlDocument = gql`
    query validateIssuerUrl($issuerUrl: String!, $externalOrgId: String, $env: String!) {
  validateIssuerUrl(
    issuerUrl: $issuerUrl
    externalOrgId: $externalOrgId
    env: $env
  ) {
    isValid
    reason
    errorMessage
  }
}
    `;

/**
 * __useValidateIssuerUrlQuery__
 *
 * To run a query within a React component, call `useValidateIssuerUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateIssuerUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateIssuerUrlQuery({
 *   variables: {
 *      issuerUrl: // value for 'issuerUrl'
 *      externalOrgId: // value for 'externalOrgId'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useValidateIssuerUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidateIssuerUrlQuery, ValidateIssuerUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<ValidateIssuerUrlQuery, ValidateIssuerUrlQueryVariables>(ValidateIssuerUrlDocument, baseOptions);
      }
export function useValidateIssuerUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateIssuerUrlQuery, ValidateIssuerUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ValidateIssuerUrlQuery, ValidateIssuerUrlQueryVariables>(ValidateIssuerUrlDocument, baseOptions);
        }
export type ValidateIssuerUrlQueryHookResult = ReturnType<typeof useValidateIssuerUrlQuery>;
export type ValidateIssuerUrlLazyQueryHookResult = ReturnType<typeof useValidateIssuerUrlLazyQuery>;
export type ValidateIssuerUrlQueryResult = ApolloReactCommon.QueryResult<ValidateIssuerUrlQuery, ValidateIssuerUrlQueryVariables>;
export const GetAriaIngestionKeyDocument = gql`
    query GetAriaIngestionKey {
  getAriaIngestionKey
}
    `;

/**
 * __useGetAriaIngestionKeyQuery__
 *
 * To run a query within a React component, call `useGetAriaIngestionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAriaIngestionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAriaIngestionKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAriaIngestionKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>(GetAriaIngestionKeyDocument, baseOptions);
      }
export function useGetAriaIngestionKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>(GetAriaIngestionKeyDocument, baseOptions);
        }
export type GetAriaIngestionKeyQueryHookResult = ReturnType<typeof useGetAriaIngestionKeyQuery>;
export type GetAriaIngestionKeyLazyQueryHookResult = ReturnType<typeof useGetAriaIngestionKeyLazyQuery>;
export type GetAriaIngestionKeyQueryResult = ApolloReactCommon.QueryResult<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>;